import { FormWizard } from './components/form/FormWizard'

function App() {
  return (
    <div className="min-h-screen py-8 px-4 sm:py-12 sm:px-6">
      {/* Header */}
      <header className="text-center mb-8 sm:mb-12">
        <a href="https://aquatic-contractors.com" className="inline-block mb-4">
          <h1 className="text-2xl sm:text-3xl font-bold text-aquatic-800">
            🐠 Aquatic Contractors
          </h1>
        </a>
        <p className="text-gray-600 max-w-md mx-auto">
          Custom aquarium design, installation, and service for Southern California.
          Over 20 years of experience.
        </p>
      </header>

      {/* Form */}
      <main>
        <FormWizard />
      </main>

      {/* Footer */}
      <footer className="text-center mt-12 text-sm text-gray-500">
        <p>
          Questions? Call us at{' '}
          <a href="tel:+18056600924" className="text-aquatic-600 hover:underline">
            (805) 660-0924
          </a>
        </p>
        <p className="mt-2">
          &copy; {new Date().getFullYear()} Aquatic Contractors. All rights reserved.
        </p>
      </footer>
    </div>
  )
}

export default App
